import { render, staticRenderFns } from "./DocumentFacets.vue?vue&type=template&id=6e56c178"
import script from "./DocumentFacets.vue?vue&type=script&lang=js"
export * from "./DocumentFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports